import React from 'react'

const NewFeed = () => {
  return (
    <div className='newfeed-container'>
      NewFeed
    </div>
  )
}

export default NewFeed
